import React from 'react';
const comparisonRows = [{
  without: '3 horas diarias pensando qué hacer → agotamiento constante',
  with: 'Más claridad para organizar y aplicar → trabajas con tranquilidad'
}, {
  without: 'Improvisación en cada clase o jornada → sensación de desorden',
  with: 'Sistema estructurado → sabes qué usar y cuándo usarlo'
}, {
  without: 'Repetir instrucciones todo el tiempo → desgaste emocional',
  with: 'Señales visuales y rutinas → el grupo entiende mejor la dinámica'
}, {
  without: 'Falta de atención o participación → frustración diaria',
  with: 'Recursos visuales y estructura → alumnos más enfocados'
}, {
  without: 'Planificación eterna los fines de semana → estrés acumulado',
  with: 'Todo organizado → recuperas tiempo personal'
}, {
  without: 'Clases que no conectan → sensación de fracaso',
  with: 'Actividades más claras → experiencias de aprendizaje más dinámicas'
}, {
  without: 'Falta de estructura → caos en el trabajo diario',
  with: 'Rutinas claras → mayor orden y continuidad'
}, {
  without: 'No saber qué hacer en momentos difíciles → bloqueo',
  with: 'Sistema de apoyo → siempre tienes una referencia práctica'
}];
export function ComparisonTableExtended() {
  return <section className="bg-brand-dark text-white py-5 px-5" data-id="element-76">
      <div className="max-w-xl mx-auto" data-id="element-77">
        <h3 className="text-base md:text-lg font-black text-white mb-4 flex items-center gap-2" data-id="element-78">
          📚 TABLA COMPARATIVA — AULA LISTA
        </h3>

        {/* Column headers */}
        <div className="grid grid-cols-2 gap-3 mb-3" data-id="element-79">
          <div className="text-xs font-bold text-red-400 flex items-center gap-1" data-id="element-80">
            ❌ Sin el sistema
          </div>
          <div className="text-xs font-bold text-green-400 flex items-center gap-1" data-id="element-81">
            ✅ Con MEGAPACK + Aula Lista™
          </div>
        </div>

        {/* Rows */}
        <div className="space-y-2" data-id="element-82">
          {comparisonRows.map((row, idx) => <div key={idx} className="grid grid-cols-2 gap-3 border-t border-gray-800/60 pt-3" data-id="element-83">
              <p className="text-xs text-gray-500 leading-relaxed" data-id="element-84">
                {row.without}
              </p>
              <p className="text-xs text-gray-300 leading-relaxed" data-id="element-85">
                {row.with}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}